/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {MockFaIconLibrary as ɵa} from './icon/mock-icon-library.service';